import type { ReactNode } from 'react';
import { CheckCircle2, AlertTriangle, XCircle, HelpCircle, ArrowRight } from 'lucide-react';

export type OperatorStatusTone = 'ready' | 'attention' | 'blocked' | 'unknown' | 'info';
const ICONS = { ready: CheckCircle2, attention: AlertTriangle, blocked: XCircle, unknown: HelpCircle, info: ArrowRight };

/** Presentational only. The data owner supplies the state; never infer it from a label or amount. */
export function OperatorStatus({ tone, children, title, className = '' }: {
  tone: OperatorStatusTone; children: ReactNode; title?: string; className?: string;
}) {
  const Icon = ICONS[tone];
  return <span className={`operator-status operator-status--${tone} ${className}`} data-tone={tone} title={title}>
    <Icon className="operator-icon" aria-hidden="true" />
    <span>{children}</span>
  </span>;
}
